import {ToastCard, toast} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface MemberRemovedToastProps {
  toastId: string | number;
  name: string;
}

export const MemberRemovedToast: FC<MemberRemovedToastProps> = ({toastId, name}) => {
  const {t} = useTranslation('team');
  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('removeModal.removedToast.title')}
      description={t('removeModal.removedToast.description', {name})}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('removeModal.removedToast.close')}
    />
  );
};

export function showMemberRemovedToast(name: string): void {
  toast.custom(id => <MemberRemovedToast toastId={id} name={name} />, {duration: 10_000});
}
